import React, { useMemo, useState } from 'react';
import { Button, Modal } from 'semantic-ui-react';
import { EEhsType, IBuilding, IEhs } from '@relab/alstom-ptw-shared';

import { EhsCreateComponent } from './EhsCreateComponent';
import { EhsViewComponent } from './EhsViewComponent';
import { TranslationComponent } from '../TranslationComponent';

interface EhsCreateModalProps {
  buildings: IBuilding[];
  ehs?: IEhs | string;
  onEhs?: (ehs: IEhs) => void;
}

export const EhsCreateModal: React.FC<EhsCreateModalProps> = ({ buildings, ehs, onEhs }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const isNewEhs = useMemo(() => typeof ehs === 'undefined' || typeof ehs === 'string', [ehs]);

  const handleModalOpen = () => setModalOpen(true);

  const handleModalClose = () => setModalOpen(false);

  const handleComplete = (ehs: IEhs) => {
    onEhs(ehs);
    handleModalClose();
  };

  return (
    <Modal
      trigger={
        <Button type={'button'} icon onClick={handleModalOpen}>
          <TranslationComponent stringKey={'EHS'} />
        </Button>
      }
      open={modalOpen}
      onClose={handleModalClose}
      closeOnDimmerClick={false}
      size={'fullscreen'}
    >
      <Modal.Header>
        <TranslationComponent stringKey={'EHS'} />
      </Modal.Header>
      <Modal.Content>
        {isNewEhs ? (
          <EhsCreateComponent
            ehsType={EEhsType.SITO}
            buildings={buildings}
            onCancel={handleModalClose}
            onComplete={handleComplete}
          />
        ) : (
          <EhsViewComponent
            buildings={buildings}
            onCancel={handleModalClose}
            onUpdated={handleComplete}
            ehsId={(ehs as IEhs)._id}
          />
        )}
      </Modal.Content>
    </Modal>
  );
};
